import * as React from 'react';
import TouchSlider from './TouchSlider';
import Visualizer from './Visualizer';

const FilterView = ({ setParam, params, audioData }) => {
	return (
		<div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
			<div style={{ width: '100%', height: '55%', margin: 'auto' }}>
                <Visualizer audioData={audioData}></Visualizer>
				{/* <FilterDisplay mix={params.MIX} fdbk={params.FDBK} time={params.TIME} /> */}
			</div>
			{Object.keys(params).map(key => (
				<div key={key} style={{ height: '22%' }}>
					<TouchSlider
						defaultValue={params[key]['frequency']}
						setValue={v => setParam(key, 'frequency', Math.pow(v, 6) / Math.pow(20000, 5))}
						min={20}
                        max={20000}
                        label={key+"F"}
					/>
				</div>
			))}
		</div>
	);
};

export default FilterView;
